/**
 * @file Pure consent-state derivation helpers — version comparison, stale-set
 * derivation, and snapshot-current evaluation. Side-effect free so they can
 * be exercised from both client and server contexts.
 */
import {
  LEGAL_CONSENT_DOCUMENT_IDS,
  LEGAL_CURRENT_VERSIONS,
  type LegalConsentDocumentId,
  type LegalVersionMap,
} from "@wmart/shared-types";

import type { LocalLegalConsentSnapshot } from "./legal-consent-storage";

export function deriveStaleDocumentsForSnapshot(
  accepted: Partial<Record<LegalConsentDocumentId, string>>,
): LegalConsentDocumentId[] {
  const stale: LegalConsentDocumentId[] = [];
  for (const id of LEGAL_CONSENT_DOCUMENT_IDS) {
    if (accepted[id] !== LEGAL_CURRENT_VERSIONS[id]) stale.push(id);
  }
  return stale;
}

export function isSnapshotCurrent(
  accepted: Partial<Record<LegalConsentDocumentId, string>>,
): boolean {
  return deriveStaleDocumentsForSnapshot(accepted).length === 0;
}

export function isLocalSnapshotCurrent(
  snapshot: LocalLegalConsentSnapshot,
): boolean {
  return isSnapshotCurrent(snapshot.acceptedVersions);
}

export function buildCurrentAcceptedVersions(): LegalVersionMap {
  return { ...LEGAL_CURRENT_VERSIONS };
}
